import * as React from "react";
import { memo } from "react";
import "./movieItemViewSkeletonStyles.css";
export var MovieItemViewSkeleton = memo(function () {
    return (React.createElement("div", { className: "movie-card-skeleton" },
        React.createElement("div", { className: "skeleton-poster" }),
        React.createElement("div", { className: "skeleton-rating" }),
        React.createElement("div", { className: "skeleton-title" })));
});



//////////////////
// WEBPACK FOOTER
// ./src/components/views/movie/MovieItemViewSkeleton.tsx
// module id = 149
// module chunks = 1